module.exports = __webpack_public_path__ + "static/rubik-f325b28a4edace7df7d73f4a669c1894.png";